import { z } from 'zod';

export const routeSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  name: z.string(),
  code: z.string(),
  sequence: z.number(),
  userId: z.string(),
  user: z.object({ id: z.string(), name: z.string() }).optional(),
  companySiteId: z.string(),
  companySite: z.object({ id: z.string(), name: z.string() }).optional(),
  routeDefinitionId: z.string(),
  routeDefinition: z.object({ id: z.string(), name: z.string() }).optional(),
});

export const getRoutesSchema = z.array(routeSchema);

export type GetRoutesResponse = z.infer<typeof getRoutesSchema>;
